module.exports = __webpack_public_path__ + "img/layer_up.71415945.svg";